<template>
  <SeoBlogArticle :content="$t('seoArticleComoGerarLeadsComEbook')" :faq="faq"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
import faq from "../../../../public/seo-faq/como-gerar-leads-com-ebook.json";
export default {
  name: 'ArticleComoGerarLeadsComEbook',
  components: { SeoBlogArticle },
  data: () => ({ faq: faq.items }),
}
</script>
